import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { cargarEventosEspeciales } from './config/eventosEspeciales';



// Se leen los codigos especiales ANTES de renderizar, para que el logo y el
// banner ya sepan que mostrar en el primer render y no haya parpadeo.
cargarEventosEspeciales().then(() => {
  ReactDOM.render(
    // <React.StrictMode>
      <App />
    // </React.StrictMode>,
    ,
    document.getElementById('root')
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


// Agregar siguiente codigo en archivo ".htaccess" de la web, para evitar error al abrir directamente link del evento

// RewriteOptions inherit

// RewriteEngine on

// <IfModule mod_rewrite.c>
//   RewriteBase /
//   RewriteRule ^index\.html$ - [L]
//   RewriteCond %{REQUEST_FILENAME} !-f
//   RewriteCond %{REQUEST_FILENAME} !-d
//   RewriteCond %{REQUEST_FILENAME} !-l
//   RewriteRule . /index.html [L]

// </IfModule>